export default __webpack_public_path__ + "static/media/Kitchen.7603867a.png";